import { Controller, Control } from 'react-hook-form'
import { StyledTextField, StyledTextFieldProps } from './StyledTextField'

type ControlledProps = {
  name: string
  control: Control<any>
  defaultValue?: string
  darkTheme?: boolean
  returnNumber?: boolean
} & Omit<StyledTextFieldProps, 'name' | 'defaultValue' | 'onChange' | 'value'>

export const FormStyledTextField = ({
  name,
  control,
  defaultValue = '',
  darkTheme,
  returnNumber = false,
  ...rest
}: ControlledProps) => {
  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      render={({ field, fieldState }) => (
        <StyledTextField
          {...field}
          onChange={(e) => {
            const value = e.target.value

            if (returnNumber) {
              if (value === '') {
                field.onChange('')
                return
              }
              const numericValue = Number(value)
              if (!isNaN(numericValue)) {
                field.onChange(numericValue)
              }
            } else {
              field.onChange(value)
            }
          }}
          error={!!fieldState.error}
          helperText=""
          darkTheme={darkTheme}
          {...rest}
        />
      )}
    />
  )
}
